import BackButton, { BackButtonProps } from "./BackButton";

export { BackButton, BackButtonProps };

export default BackButton;
